const setUnifiedError = (text) => {
  const errorEle =
    document.querySelector("#error-message-show") ||
    document.querySelector("#error-message-hidden");
  errorEle?.setAttribute("banner-message", text);
  errorEle?.setAttribute("id", "error-message-show");
};

const removeUnifiedError = () => {
  const errorEle =
    document.querySelector("#error-message-show") ||
    document.querySelector("#error-message-hidden");
  errorEle?.setAttribute("id", "error-message-hidden");
};

const isPartnerCentral = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramToken = urlParams.get("params");

  let payload = {};
  payload = JSON.parse(atob(paramToken?.split(".")[1]));

  return payload.extras.brand === "PARTNER-PORTAL";
};

export { setUnifiedError, removeUnifiedError, isPartnerCentral };
